import { useEffect, useState } from "react";
import { api } from "../../lib/api";

// Loads the user's Money/Love/Healing cities; flags paywall-locked and missing-natal states.
export function useTopCities() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [needsNatal, setNeedsNatal] = useState(false);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await api.get("/users/top-cities");
        if (alive) setData(res.data);
      } catch (e) {
        if (!alive) return;
        if (e?.response?.status === 400) {
          setNeedsNatal(true);
          setData(null);
        } else {
          setData({ locked: true });
        }
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  return { data, loading, needsNatal };
}
